import { createSelector } from 'selectors'
import { constants } from './dependentSelectBox.constant'

const getDependentSelectBoxes = () =>
	createSelector<NodeListOf<HTMLSelectElement>>({ selector: constants.selector.dependentSelectBox }, true)

export const getDependentSelectBoxComponents = () => ({
	dependentSelectBoxes: getDependentSelectBoxes(),
})
